import { Button } from '@/components/Elements/Button/Button';
import { Box, Grid, InputLabel, Stack, TextField, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { LoginFormType } from '@/features/reservation/types/LoginFormType';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { resetPassword } from 'aws-amplify/auth';
import { PageName } from '.';
import { useState } from 'react';

const schema: yup.ObjectSchema<Pick<LoginFormType, 'email'>> = yup.object({
  email: yup
    .string()
    .required('メールアドレスを入力してください。')
    .email('メールアドレスを正しい形式で入力してください')
});

export const ResetPasswordByEmail = (props: {
  setActivePage: React.Dispatch<React.SetStateAction<PageName>>;
  setUserName: (userName: string) => void;
}) => {
  const [hasError, setError] = useState(false);

  const {
    handleSubmit,
    control,
    getValues,
    formState: { errors }
  } = useForm<Pick<LoginFormType, 'email'>>({
    defaultValues: {
      email: ''
    },
    resolver: yupResolver(schema)
  });

  const onSubmit = async () => {
    const mailaddress = getValues('email');
    try {
      await handleResetPassword(mailaddress);
      props.setUserName(mailaddress);
      props.setActivePage(PageName.ResetPasswordForm);
    } catch (error) {
      // セキュリティ上、ユーザーが存在しなくても次のページに進む
      props.setUserName(mailaddress);
      props.setActivePage(PageName.ResetPasswordForm);
    }
  };

  // メールアドレスの送信
  const handleResetPassword = async (username: string) => {
    try {
      await resetPassword({ username });
      setError(false);
    } catch (error) {
      setError(true);
    }
  };

  const ErrorMessage = (props: { message: string | undefined }) => {
    if (!props.message) return null;
    return (
      <Typography color="error" style={{ fontSize: '12px', marginLeft: '4px' }}>
        {props.message}
      </Typography>
    );
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* 見出しと説明文 */}
      <Typography className="font-bold" variant="h5" align="center" sx={{ mt: 4, mb: 3 }}>
        パスワードをお忘れですか？
      </Typography>
      <Typography variant="body1" align="center" color="textSecondary" mb={4}>
        以下にメールアドレスを入力してください。
        <br />
        パスワードをリセットするためのメッセージが送信されます。
      </Typography>

      <Grid container direction={'row'} justifyContent={'center'} spacing={2}>
        <Grid item xs={12} sm={8}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* メールアドレス入力フィールド */}
            <Grid item xs={12}>
              <Stack direction={'column'}>
                <InputLabel className="font-bold">
                  <Box fontSize={14} ml={0.5} color={'#424242'}>
                    メールアドレス
                  </Box>
                </InputLabel>
                <Controller
                  name="email"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField
                        {...field}
                        type="email"
                        placeholder="example@healthinterview.clinic"
                        fullWidth
                        size="small"
                        sx={{ backgroundColor: '#fff', marginTop: '4px !important' }}
                        error={!!error}
                      />
                      {!!error && <ErrorMessage message={errors[field.name]?.message} />}
                    </>
                  )}
                />
              </Stack>
            </Grid>
            <Grid item sx={{ mt: 2 }}>
              <Button type="submit" variant="main" size="lg" className="w-full">
                <div>パスワードをリセットする</div>
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Box>
  );
};
